var React = require('react');

function North (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"dc76a04ac91090244418763e1e1d2a"),React.createElement("path",{"d":"M31.68 14.694h-4.051c-0.522-4.051-3.005-7.45-6.534-9.277l1.437 3.398c1.962 1.83 3.136 4.314 3.136 7.187 0 5.357-4.442 9.802-9.802 9.802s-9.664-4.448-9.664-9.805c0-2.874 1.178-5.357 3.136-7.187l1.437-3.398c-3.398 1.83-6.010 5.226-6.403 9.277h-4.051v2.614h4.051c0.653 5.488 4.835 9.802 10.323 10.323v4.051h2.614v-4.051c5.485-0.653 9.798-4.835 10.32-10.323h4.051v-2.611z","key":1}),React.createElement("path",{"d":"M16 9.466l5.226 2.614-5.226-11.76-5.226 11.76 5.226-2.614z","key":2})]);
}

North.defaultProps = {"version":"1.1","width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = North;

North.default = North;
